import { useState } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { getStoredAuth, setStoredAuth } from './api/client'
import { useHotelProfile } from './api/hooks'
import type { Customer } from './api/types'
import { Layout } from './layouts/Layout'
import { HomePage } from './routes/HomePage'
import { BookingPage } from './routes/BookingPage'
import { ConfirmationPage } from './routes/ConfirmationPage'
import { AccountPage } from './routes/AccountPage'

export default function App() {
  const queryClient = useQueryClient()
  const [auth, setAuth] = useState<{ token: string; customer: Customer } | null>(() => getStoredAuth())
  const { data: hotel } = useHotelProfile()

  const setCustomerAuth = (next: { token: string; customer: Customer } | null) => {
    setAuth(next)
    setStoredAuth(next)
    queryClient.invalidateQueries({ queryKey: ['customer-reservations'] })
  }

  return (
    <Layout hotel={hotel} customer={auth?.customer || null} onLogout={() => setCustomerAuth(null)}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/booking" element={<BookingPage customer={auth?.customer || null} setCustomerAuth={setCustomerAuth} />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
        <Route path="/account" element={<AccountPage customer={auth?.customer || null} setCustomerAuth={setCustomerAuth} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}
